module.exports = __webpack_public_path__ + "media/images/banks/vn-bidv-4131ab690f917ad0425ab30f149ceb1e.png";